import React from "react";

import { useTranslation } from "react-i18next";
import { FiRefreshCw } from "react-icons/fi";

import { Button } from "../../Form";
import { Color } from "../../Form/Button";
import useStyles, { HeaderContainer } from "./styles";

interface FilesHeaderProps {
  typeFolder: string;
  nextTypeFolder?: string | null;
  onSwitchTypeFolder?: () => void;
  prependSlot?: React.ReactNode;
  appendSlot?: React.ReactNode;
}

export const FilesHeader = (props: FilesHeaderProps) => {
  const { typeFolder, onSwitchTypeFolder, nextTypeFolder, prependSlot, appendSlot } = props;
  const { t } = useTranslation();
  const classes = useStyles();

  return (
    <HeaderContainer style={{ marginBottom: "39px" }}>
      {prependSlot}

      <span className={classes.typeFolder}>
        {typeFolder} {t("folders")}
      </span>

      <Button
        customColor={Color.INFO}
        style={{ marginLeft: "16px" }}
        onClick={() => onSwitchTypeFolder?.()}
      >
        <div className="d-flex align-items-center justify-content-center">
          <FiRefreshCw color="#3F6280" />
          <span className={classes.switchToText}>
            {t("switchTo")} {nextTypeFolder} {t("folders")}
          </span>
        </div>
      </Button>

      {appendSlot}
    </HeaderContainer>
  );
};
